/* eslint-disable @typescript-eslint/no-empty-function */
import React, { Component } from 'react'
import Icon, { IconType } from '@bt-react/components/Icon'
import InputDeviceSelector from '@bt-react/components/InputDeviceSelector'
import { Option } from '@bt-react/components/InputSourceSelector'
import { MicrophoneSelectorProps, MicrophoneSelectorState } from './types'
import style from './MicrophoneSelector.module.scss'
import classnames from 'classnames'

class MicrophoneSelector extends Component<MicrophoneSelectorProps, MicrophoneSelectorState> {

  constructor (props) {

    super(props)
    this.state = {
      options: this.getOptions()
    }

  }

  componentDidUpdate (prevProps) {

    if (prevProps.options !== this.props.options) this.setState({ options: this.getOptions() })

  }

  previewComponent = () => {

    return this.props.isDialInConnected
      ? <div className={style['microphone--disabled']}><Icon name={IconType.iconName.microphoneSlash} colour={IconType.colour.danger} /><span className={style['microphone-text--disabled']}>Mic disabled</span></div>
      : undefined

  }

  getOptions = (): Option[] => {

    const options: Option[] = []

    for (const [ deviceId, deviceInfo ] of this.props.options.entries()) {

      if (deviceInfo.kind === 'audio') {

        options.push({
          label: deviceInfo.label,
          value: deviceId
        })

      }

    }

    return options

  }

  render () {

    return <div
      className={
        classnames(style['microphone'], {
          [style['microphone--no-label']]: !this.props.label
        })
      }
      data-bdd='microphone-selector'
    >
      <InputDeviceSelector
        deviceType='microphone'
        selectedDeviceId={this.props.selectedMicrophone}
        label={this.props.label}
        onDeviceChange={this.props.onMicrophoneChange}
        onListLoaded={() => {}}
        switchComponent={this.props.switchComponent}
        previewComponent={this.previewComponent()}
        options={this.state.options}
        disabled={this.props.isDialInConnected}
        optionsPlaceholderText={this.props.isDialInConnected ? 'Telephone audio is connected' : undefined}
        disabledText='Telephone audio is connected'
      />
      {
        this.props.isDialInConnected
          ? <div data-bdd='microphone-selector-disabled-message' className={style['microphone-details']}>
            <span>Note: End your telephone connection to enable computer audio.</span>
          </div>
          : undefined
      }
    </div>

  }

}

export default MicrophoneSelector
